







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
@Component({
  components: {
    PageTitle,
    AdminIframe,
  }
})
export default class SettlementAdjustmentList extends Vue {
  private title = '정산 보정 관리';
  private remoteSrc = '';
  private setRemoteSrc() {
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
  
  
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + '/configuration/settlement-adjustment-list?' + queryString;
  }
  
  created() {
    this.setRemoteSrc();
  }
}
